export const FILE_TYPES = {
  APK: 'application/vnd.android.package-archive',
  HTML: 'text/html',
  PLAIN: 'text/plain',
  CERTIFICATE: 'application/x-x509-ca-cert',
};
